// Component
export default () => {
    const modals = Array.from(document.querySelectorAll('.modal-team'))

    // If there's no team modal, return
    if (!modals.length)
        return

    modals
        .forEach((modal) => {
            const control = (el) => {
                const trigger = el.relatedTarget

                if (!trigger)
                    return

                const { teamId } = trigger.dataset

                let parentsEl = trigger.parentElement

                let content

                while (parentsEl !== document.documentElement) {
                    content = parentsEl.querySelector(
                        `[data-team-content="${teamId}"]`)

                    if (content)
                        break

                    parentsEl = parentsEl.parentElement
                }

                const contentHeading = content
                    && content.querySelector('.modal-team-name[id]')

                const popup = modal.querySelector('[data-team-popup]')

                if (content && popup)
                    popup.innerHTML = content.innerHTML

                if (contentHeading)
                    modal.setAttribute('aria-labelledby', contentHeading.id)
            }

            modal.addEventListener(
                'show.bs.modal',
                control.bind(this)
            )

            modal.addEventListener(
                'hide.bs.modal',
                (e) => modal.removeAttribute('aria-labelledby')
            )
        })
}
